import ShareRedirect from './share-redirect';

const ShareWeAll = () => <ShareRedirect shareType="profile" />;

export default ShareWeAll;
